export default __webpack_public_path__ + "static/media/forgot-password-image.d431bd5d.svg";